import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button } from '@/ui';
import styled from 'styled-components';

export const StyledItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid ${COLORS.LIGHT_GRAY};
  background: ${COLORS.WHITE};
  text-align: left;
`;

export const StyledItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledItemTitle = styled.div`
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  text-transform: uppercase;
`;

export const StyledButton = styled(Button)`
  &&& {
    padding: 0;
    min-height: 0;
    border: none;
    height: auto;

    &&&:hover {
      border: none;
    }
  }
`;
